import { SectionParagraph, SectionTitle } from '@/components/shared/Content';
import { type BaseLottieConfig, Box, Flex, font } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import styled from 'styled-components';

export type LottieAnimationData = BaseLottieConfig<'svg'>['animationData'];
export const LottieItem = styled(Box)`
  height: 165px;
  width: 165px;
`;
export const SectionBody = styled(Flex)`
  width: 1000px;
  max-width: 100%;
  gap: 3em;
  text-align: center;
  display: none;
  ${MEDIA_QUERIES.tabletAndDesktop`
    display: flex;
  `}
`;

export const ItemWrapper = styled(Flex)`
  width: 100%;
  text-align: center;

  ${MEDIA_QUERIES.tablet`
        width: auto;
    `}
`;
export const ItemTitle = styled.h4`
  ${font('main', { fontSize: '2.8rem', lineHeight: 1.3, fontWeight: 700 })};
  margin: 0.75em 0 0.5em 0;

  ${MEDIA_QUERIES.mobile`
        ${font('main', {
          fontSize: '2.4rem',
          lineHeight: 1.3,
          fontWeight: 700,
        })};
        white-space: pre-line;
        max-width: min(300px, 100%);
    `}
`;
export const ItemText = styled.p`
  ${font('main', { fontSize: '1.6rem', lineHeight: '2.2rem' })};
`;
export const MainTitle = styled(SectionTitle)`
  padding-bottom: 1rem;

  ${MEDIA_QUERIES.mobile`
        padding-bottom: 20px;
        max-width: min(300px, 100%);
    `}
`;
export const Subtitle = styled(SectionParagraph)`
  ${MEDIA_QUERIES.tabletAndDesktop`
         white-space: normal;
    `}
`;

export interface Item {
  title: string;
  subtitle: string;
  image: StaticImageData;
}

export interface GalleryProps {
  items: {
    left: Item;
    center: Item;
    right: Item;
  };
}
